<ng-container *ngIf=left>
  <li><a pageScroll [pageScrollEasing]="easeInOutCubic" routerLink="/" href="#ueber" routerLinkActive="active">{{'ABOUT'|translate}}</a></li>
  <li><a pageScroll [pageScrollEasing]="easeInOutCubic" routerLink="/" href="#kompetenzen" routerLinkActive="active">{{'COMPETENCIES'|translate}}</a></li>
</ng-container>

<ng-container *ngIf=right>
  <li><a routerLink="/impressum" routerLinkActive="active">{{'LEGAL'|translate}}</a></li>
  <li><a routerLink="/datenschutz" routerLinkActive="active">{{'PRIVACY'| translate}}</a></li>
</ng-container>
